import { Button, Card, CardActions, CardContent, CardHeader, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import MonoText from "components/MonoText";
import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link as RouterLink } from "react-router-dom";
import { useState } from "react";
import SetActiveMastery from "./components";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
  content: {
  },
  actions: {
    flexDirection: "row",
    alignItems: "flex-start",
    "& > * + *": {
      marginLeft: 0
    }
  },
  notice: {
    marginTop: theme.spacing(1)
  },
  italics_light: {
    opacity: 0.7,
    fontStyle: "italic",
  },
  spinner: {
    marginTop: theme.spacing(3),
  },
  mono: {
    fontFamily: ["Roboto Mono", "monospace"],
  },
  topheader: {
    marginBottom: 5
  },
  xp: {
    fontSize: "0.8rem"
  }
}));

const ActiveMasteryPreview = props => {
  const { mastery, title = "Active Mastery", student_id, className, reload, ...rest } = props;
  const classes = useStyles();
  const [openChangeMastery, setOpenChangeMastery] = useState(false);

  if (!mastery) return null;

  const onCloseChangeMastery = () => {
    setOpenChangeMastery(false);
    reload();
  }

  const user_mastery = mastery.user_mastery_level;
  return (
    <Card {...rest} className={clsx(classes.root, className)}>
      <CardHeader title={`${title} Info`} />
      <Divider />
      <CardContent className={classes.content}>
        {mastery && (
          <Fragment>
            <Typography variant="h2" className={classes.topheader}>{user_mastery.xp_obtained.toString()}/{mastery.xp_complete}<span className={classes.xp}>XP</span></Typography>
            <Typography variant="h3">{mastery.name_en}</Typography>
            <Typography className={classes.mono} variant="body1" >
              <MonoText>{mastery.code}</MonoText>
            </Typography>
          </Fragment>
        )}
      </CardContent>
      <CardActions className={classes.actions}>
        <Button component={RouterLink} size="small" to={`/masteries/${mastery.id}/summary`}>
          View {title} Details
        </Button>
        <Button size="small" onClick={() => setOpenChangeMastery(true)}>
          Change {title}
        </Button>
      </CardActions>
      <SetActiveMastery open={openChangeMastery} onClose={onCloseChangeMastery} activeMastery={mastery.id} student_id={student_id} />
    </Card>
  );
};

ActiveMasteryPreview.propTypes = {
  className: PropTypes.string,
  onSearch: PropTypes.func
};

export default ActiveMasteryPreview;
